export const ClaimTypes = {
  'adult': 'Контент для взрослых',
  'mat': 'Мат',
  'twink': 'Мультиаккаунт',
  'insult': 'Оскорбление',
  'adver': 'Реклама',
  'spam': 'Спам',
  'other': 'Другое'
}

export default interface CommentClaim {
  // Из БД
  comment_id: number,
  user_id: number,
  claim_date: string,
  claim_type: string,
  claim_status: number,
  moder_user_id: number|null,

  // Добавлено в модели
  user: {
    userName: string,
    profileUrl: string
  },
  isOwner: boolean
}
